module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1505-b4171160d291079406309c43e1a4b2bb.png";